import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import server from '../../../api/server';
import { setVOIData } from '../../../actions';
import Card from '../ui/Card';
import Button from '../ui/Button';
import VOIApplicantCard from './VOIApplicantCard';
import { UserIcon } from '../ui/icons';

// Redesign of newadmin/VOI.js — same /admin/requestvoi request +
// setVOIData dispatch; per completed applicant renders VOIApplicantCard.
const VOISection = () => {
    const VOI = useSelector((s) => s.admin.active_application.VOI);
    const applicationId = useSelector((s) => s.admin.active_application.application.id);
    const user = useSelector((s) => s.user);
    const dispatch = useDispatch();

    const [requestDisable, setRequestDisable] = useState(false);

    const requestVOI = async () => {
        setRequestDisable(true);
        const response = await server.post('/admin/requestvoi', {
            id: user.token,
            application_id: applicationId,
        });
        dispatch(setVOIData(response.data));
        setRequestDisable(false);
    };

    if (VOI == null) {
        return (
            <Card
                title="Request Verification of Identity"
                subtitle="Verification of Identity"
                icon={<UserIcon className="h-5 w-5" />}
            >
                <p className="text-sm text-[#6B7280] mb-4">
                    Click the below link to commence the OCR Labs Verification of Identity process with your
                    clients. Once you click the below link, the verification of identity box will appear on
                    their client link. Each borrower will need to complete a separate report.
                </p>
                <Button disabled={requestDisable} onClick={requestVOI}>
                    {requestDisable ? 'Requesting…' : 'Request Verification of Identity'}
                </Button>
            </Card>
        );
    }

    return (
        <div className="space-y-4">
            {Object.keys(VOI.applicants).map((key) => {
                if (VOI.applicants[key].completed == true) {
                    return <VOIApplicantCard key={key} applicantId={key} />;
                }
                return (
                    <Card
                        key={key}
                        title="Verification of Identity in Progress"
                        subtitle="Verification of Identity"
                        icon={<UserIcon className="h-5 w-5" />}
                    >
                        <p className="text-sm text-[#6B7280]">
                            Your borrowers are yet to finalise the verification of identity process. Once
                            completed, their identification process and report will be available here.
                        </p>
                    </Card>
                );
            })}
        </div>
    );
};

export default VOISection;
